import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { OffboardingService } from 'src/app/services/offboarding.service';
import { Note } from 'src/app/shared/models/note/note';
import { ClientNotesResponse } from 'src/app/shared/models/note/client-notes-response';

@Component({
  selector: 'app-offboarding-notes',
  templateUrl: './offboarding-notes.component.html',
  styleUrls: ['./offboarding-notes.component.scss'],
})
export class OffboardingNotesComponent implements OnInit, OnChanges {
  @Input() clientId: number;
  @Input() createdByUserId: number;
  @Input() newNote: Note;
  @Output() noteCreateError = new EventEmitter<any>();

  clientNotes: Note[] = [];
  noNotes: boolean = false;
  loadingNotes: boolean = false;
  noteText: string;
  noteSaving = false;
  searchText: string = '';

  constructor(private offboardingService: OffboardingService) {}

  ngOnInit(): void {
    this.GetClientNotes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['newNote']) {
      const noteChange = changes['newNote'];
      if (!noteChange.firstChange && (noteChange.currentValue !== noteChange.previousValue || noteChange.previousValue === undefined)) {
        this.handleRecordAdded(noteChange.currentValue);
      }
    }
  }

  GetClientNotes() {
    this.loadingNotes = true;
    this.offboardingService.GetOffboardingClientNotes(this.clientId).subscribe({
      next: (response: ClientNotesResponse) => {
        this.clientNotes = response.notes;
        this.noNotes = this.clientNotes.length === 0;
      },
      error: (error) => {
        this.noteCreateError.emit(error);
      },
      complete: () => {
        this.loadingNotes = false;
      },
    });
  }

  onSubmit(noteForm: NgForm) {
    if (noteForm.invalid) {
      noteForm.form.markAllAsTouched();
      return;
    }
    this.SaveClientNote(noteForm);
  }

  SaveClientNote(noteForm: NgForm) {
    this.noteSaving = true;
    this.offboardingService.CreateOffboardingClientNote(this.clientId, this.createdByUserId, this.noteText).subscribe({
      next: (newNote: Note) => {
        this.handleRecordAdded(newNote);
        this.noteText = '';
        noteForm.resetForm();
      },
      error: (error) => {
        this.noteSaving = false;
        this.noteCreateError.emit(error);
      },
      complete: () => {
        this.noteSaving = false;
      },
    });
  }

  private handleRecordAdded(note: Note) {
    note.recentlyUpdated = true;
    setTimeout(() => {
      note.recentlyUpdated = false;
    }, 3000);

    if (this.clientNotes.length === 0) {
      this.GetClientNotes();
    } else {
      this.clientNotes.unshift(note);
      this.noNotes = false;
    }
  }
}
